import React, { Suspense, useEffect } from 'react';
import { Redirect, Switch, useHistory } from 'react-router-dom';
import { GlobalStyle } from '@styles/global';
import { Hooks } from '@hooks/index';
import { ToastContainer } from 'react-toastify';
import { QueryClient, QueryClientProvider } from 'react-query';

import { Loading } from '@components/generic/Loading';
import { Route } from './Route';
import { Public } from './containers/public';

import {
  LandPage,
  OuvidoriaPage,
  ResetPage,
  GenericNotFound,
  OuvidoriaAdm,
  DashboardDefaults,
  ActiveAccount,
} from './paths';

import { Private } from './containers/private';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

export const Routes: React.FC = () => {
  // const strUser = localStorage.getItem('user');
  // const user = strUser ? JSON.parse(strUser) : null;
  // const history = useHistory();

  // if (history.location.pathname !== '/' && !user) {
  //   console.log('>>> Module:Routes:history', history.location.pathname, user);
  //   return <Redirect to="/" />;
  // }

  return (
    <Hooks>
      <QueryClientProvider client={queryClient}>
        <Suspense fallback={<Loading fullScreen />}>
          <GlobalStyle />
          <ToastContainer autoClose={2000} />

          <Switch>
            <Route path="/admin/:path+" exact isPrivate>
              <Private>
                <Route
                  path="/admin/dashboard"
                  component={DashboardDefaults}
                  isPrivate
                />
                <Route
                  path="/admin/ouvidoria"
                  component={OuvidoriaAdm}
                  isPrivate
                />
                {/* <Route component={GenericNotFound} isPrivate />
                <Redirect to="/404" /> */}
              </Private>
            </Route>

            {/* <Route path="/:path+" exact> */}
            <Route exact path="/" component={LandPage} />
            <Route exact path="/ouvidoria" component={OuvidoriaPage} />
            <Route exact path="/reset" component={ResetPage} />
            <Route exact path="/active" component={ActiveAccount} />
            <Route component={GenericNotFound} />
            <Redirect to="/404" />
            {/* </Route> */}
          </Switch>
        </Suspense>
      </QueryClientProvider>
    </Hooks>
  );
};
